import { getOpportunityById } from "@fp/admin-api-client/client";
import type { OpportunityDto } from "@fp/admin-api-client";
import { AdminPageHeader } from "@/components/admin-page-header";
import { PageLoading } from "@fp/ui/components/base/page-layout/page-layout";
import { AdminLayout } from "@/components/admin-layout";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { HttpStatusCode } from "axios";

export const SignUpPageContent = ({
	opportunity,
}: {
	opportunity?: OpportunityDto;
}) => {
	return (
		<>
			<div className="flex flex-col flex-1"></div>
			<div className="flex-1 flex items-end pt-6 max-h-1/2">
				<div className="size-full bg-white border-1 border-primary rounded-t-3xl px-8 pt-8 pb-4 shadow-lg flex flex-col justify-between">
					<div className="text-center space-y-6">
						<h2 className="text-2xl font-semibold text-gray-800">
							Create an account to continue adding team members to the Opp!
							{opportunity?.id}
						</h2>
					</div>
				</div>
			</div>
		</>
	);
};

export const Route = createFileRoute("/opps/$oppId/edit/signup")({
	component: RouteComponent,
	loader: async ({ params }) => {
		const { oppId } = params;
		const result = await getOpportunityById(oppId);
		if (result.status !== HttpStatusCode.Ok) {
			throw new Error("Failed to get opportunity");
		}

		return result.data;
	},
	pendingComponent: () => <PageLoading />,
});

function RouteComponent() {
	const opportunity: OpportunityDto = Route.useLoaderData();
	const { oppId } = Route.useParams();
	const router = useRouter();

	return (
		<AdminLayout className="bg-gradient-to-b from-blue-300 to-blue-400">
			<AdminPageHeader
				title="Sign Up"
				parent={{
					url: router.buildLocation({
						to: "/opps/$oppId",
						params: { oppId },
					}).href,
					label: "Opp Detail",
				}}
			/>
			<SignUpPageContent opportunity={opportunity} />
		</AdminLayout>
	);
}
